/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ReactNode } from 'react';
import { checkAuthentication } from '@jira/spa-apps__interceptors/src/checkAuthentication.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { RedirectToLoginPage } from './RedirectToLoginPage.tsx';

export type Props = {
	children: ReactNode;
};

export const AuthenticationCheck = ({ children }: Props): React.JSX.Element => (
	<TenantContextSubscriber>
		{({ tenantContext }) => {
			if (checkAuthentication(tenantContext)) {
				return children;
			}
			return <RedirectToLoginPage />;
		}}
	</TenantContextSubscriber>
);
